// extracted by mini-css-extract-plugin
export default {"wrapper":"react_project_info_wrapper__fhNt0"};